import ga from "./ga";
import { sanitizeString } from "../string";
// import pixel from "./pixel";

const {
  dataLayer,
  // genomeTP
} = window;

export const trackStageViewthrough = (stageNumber = "", stageName = "") => {
  ga.onStageViewthrough(dataLayer, stageNumber, stageName);
  // pixel.onSelectProductLine(genomeTP, productSeries);
};

export const trackNavBtnClick = (stageNumber = "", stageName = "") => {
  ga.onNavBtnClick(dataLayer, stageNumber, stageName);
  // pixel.onSelectProductLine(genomeTP, productSeries);
};

export const trackPlay = (productSeries = "", playCount = 0) => {
  ga.onPlayClick(dataLayer, sanitizeString(productSeries), playCount);
  // pixel.onSelectProductLine(genomeTP, productSeries);
};

export const trackStartCardCTA = () => {
  ga.onStartCardCTAClick(dataLayer);
  // pixel.onSelectProductLine(genomeTP, productSeries);
};

export const trackReplay = (productSeries = "") => {
  ga.onReplayClick(dataLayer, sanitizeString(productSeries));
  // pixel.onSelectProductLine(genomeTP, productSeries);
};

export const trackSizzleStart = (productSeries = "") => {
  ga.onSizzleStart(dataLayer, sanitizeString(productSeries));
  // pixel.onSelectProductLine(genomeTP, productSeries);
};

export const trackSizzleEnd = (productSeries = "") => {
  ga.onSizzleEnd(dataLayer, sanitizeString(productSeries));
  // pixel.onSelectProductLine(genomeTP, productSeries);
};

export const trackPortrait = () => {
  ga.onPortrait(dataLayer);
  // pixel.onSelectProductLine(genomeTP, productSeries);
};

export const trackVideoPause = (productSeries = "", playedTime = "") => {
  ga.onVideoPause(dataLayer, productSeries, playedTime);
  // pixel.onSelectProductLine(genomeTP, productSeries);
};

export const trackVideoEnd = (productSeries = "", playedTime = "") => {
  ga.onVideoEnd(dataLayer, productSeries, playedTime);
  // pixel.onSelectProductLine(genomeTP, productSeries);
};

export default {
  trackPlay,
  trackStartCardCTA,
  trackReplay,
  trackSizzleStart,
  trackSizzleEnd,
  trackNavBtnClick,
  trackStageViewthrough,
  trackPortrait,
  trackVideoPause,
  trackVideoEnd,
};
